
const HeartOfSundaySchoolTeacher = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/teacher.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            Behind the Scenes: The Heart of a Sunday School Teacher
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Discover the dedication, passion, and love that Sunday School teachers pour into shaping the next generation of faith.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            When we think of Sunday School, the focus often goes to the children, the lessons, or the activities. Rarely do we
            stop to consider the dedicated individuals who pour their time, energy, and love into nurturing the next generation
            of faith. Sunday School teachers play a quiet but powerful role in shaping hearts, minds, and lives — often without
            recognition or applause.
          </p>

          <p className="mb-6">
            Behind every lesson plan, every story told, and every prayer offered is a teacher whose heart beats for the spiritual
            growth of children. Let’s explore the world behind the scenes of Sunday School and understand why these teachers
            are truly the unsung heroes of faith education.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. Passion That Goes Beyond the Classroom
            </h2>
            <p>
              Sunday School teachers aren’t just volunteers filling a schedule. They are called to guide and mentor children,
              spending hours preparing lessons, thinking creatively about activities, and finding ways to make Scripture
              engaging and relatable. Their passion extends beyond teaching; it’s about planting seeds of faith, hope, and love
              that last long after class ends.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Patience, Compassion, and Understanding
            </h2>
            <p>
              Every child comes with unique personalities, learning styles, and challenges. Sunday School teachers exercise
              extraordinary patience and compassion, celebrating small victories, gently guiding missteps, and providing a
              safe space where children feel seen, heard, and loved.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Creativity and Adaptability
            </h2>
            <p>
              Teaching faith requires imagination and adaptability. Teachers craft lessons that engage young minds using
              stories, crafts, games, songs, and digital tools. They ensure timeless truths are relatable to modern challenges,
              making learning meaningful and memorable.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Mentorship That Lasts a Lifetime
            </h2>
            <p>
              A Sunday School teacher’s impact extends far beyond the classroom. They often serve as mentors and role models,
              guiding children during challenges and celebrating milestones. Their influence shapes spiritual beliefs, character,
              resilience, and confidence.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Emotional and Spiritual Investment
            </h2>
            <p>
              Sunday School teachers invest not just time but emotion and spirit. They pray for students, celebrate achievements,
              and share in struggles, modeling God’s love, grace, and compassion through every interaction.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. The Joy of Small Moments
            </h2>
            <p>
              Teachers find joy in small, everyday moments: a child reciting a memory verse for the first time, a thoughtful
              question, or laughter during an activity. These moments, though seemingly minor, are the heartbeat of Sunday School.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              7. The Unsung Heroes of Faith Education
            </h2>
            <p>
              Sunday School teachers rarely seek recognition, yet their work is invaluable. They are the quiet architects of
              spiritual growth, planting seeds that blossom into lifelong faith and guiding children to become compassionate,
              thoughtful, and spiritually grounded adults.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: A Heart That Inspires Generations
            </h2>
            <p>
              Behind every Sunday School classroom is a teacher whose heart is committed to God and children. Their dedication,
              creativity, patience, and love transform ordinary Sunday mornings into moments of faith formation, hope, and
              inspiration. They don’t just teach lessons — they shape hearts, nurture souls, and raise the next generation of
              believers.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Sunday School Teacher</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Faith Education</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Mentorship</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Community Impact</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeartOfSundaySchoolTeacher;